import { render, staticRenderFns } from "./PredefinedStocks.vue?vue&type=template&id=0d5f110c&"
import script from "./PredefinedStocks.vue?vue&type=script&lang=js&"
export * from "./PredefinedStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pzuber/Desktop/Repozytoria/HairTalk/hairtalk/HairTalk/HT_Portal_VUE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer,VDataTable,VDialog,VDivider,VIcon,VSnackbar,VSpacer,VTextField,VToolbar})
